export default {
  LOGO: 'logo',
  PROFORMA_TEMPLATE: 'proforma-template',
  STUDENT_MANAGEMENT: 'student-management'
};
